module.exports = __webpack_public_path__ + "img/graph.e60a440e.svg";